import $ from 'jquery';

class BaseRichContentPage {
	constructor(params = {}) {
		this.params = params;
		this.init();
	}
	
	init() {
		if (this.params.loadContent) {
			this.params.loadContent();
		} else {
			this.loadContent();
		}
		
		this.hashChecker();
		
		$(document.body).on('lazyLoadError', (ev, element) => {
			$(element).hide();
		});
	}
	
	loadContent() {
		import(
			/* webpackChunkName: "RichContentPageContent" */
			'../components/RichContentPageContent'
			)
			.then(({'default': RichContentPageContent}) => {
				new RichContentPageContent(window.richContentPageParams);
			});
	}
	
	hashChecker() {
		const scrollTarget = location.hash && $(`${location.hash}`);
		
		if (scrollTarget && scrollTarget.length) {
			$('html, body').scrollTop(
				scrollTarget.offset().top - 150
			);
		}
	}
	
}

export default BaseRichContentPage;